import { addIgnores } from "./matcher-utils";
import { BehaviorSubject, of } from "rxjs";
import { delay } from "rxjs/operators";
import { filterWithDebounce } from "./utils";
import { KEY_KEYS_CONSTANTS, noop, } from "@alk/core";
export const globalOptions = [
  { id: 'test', name: 'test' },
  { id: 'test2', name: 'test 2' },
  { id: 'test3', name: 'test 3' },
  { id: 'other3', name: 'other 3' },
  { id: 'ccy1', name: 'EUR/USD' },
  { id: 'ccy2', name: 'EUR/JPY' },
  { id: 'ccy3', name: 'EURGBP' },
  { id: 'ccy4', name: 'EUR-MXN' },
  { id: 'ccy5', name: 'USD JPY' },
];
const markItemOptions = [
  { id: 'test', name: 'test' },
  { id: 'test2', name: 'test2' },
  { id: 'test3', name: 'test3' },
  { id: 'test+', name: 'test+' },
  { id: 'ccy1', name: 'EUR/USD' },
  { id: 'ccy2', name: 'EUR/JPY' },
  { id: 'ccy3', name: 'EURGBP' },
  { id: 'ccy4', name: 'EUR-MXN' },
  { id: 'ccy5', name: 'USD JPY' },
  { id: 'reportId1', name: 'FinReportML | RTK-1 | IAM Discount' },
];
const optionsWithPinned = [
  { id: 'test', name: 'test', pinned: true },
  { id: 'test2', name: 'test2' },
  { id: 'test3', name: 'test3' },
  { id: 'ccy1', name: 'EUR/USD', pinned: true },
  { id: 'ccy2', name: 'EUR/JPY', pinned: true },
  { id: 'ccy3', name: 'EURGBP' },
  { id: 'ccy4', name: 'EUR-MXN' },
  { id: 'ccy5', name: 'USD JPY' },
  { id: 'long1', name: 'Option with a really long name' },
  { id: 'long2', name: 'Option_with_another_really_long_name' },
  { id: 'long3', name: 'Option with a name that is so long it does not make sense anymore' },
];
const asyncOptions = [
  { id: 'folder1', name: 'Folder 1' },
  { id: 'folder2', name: 'Folder 2' },
  { id: 'folder3', name: 'Folder 3' },
  { id: 'folder4', name: 'Folder 4' },
  { id: 'folder5', name: 'Folder 5' },
];
const asyncOptionsMore = [
  { id: 'folder1', name: 'Folder 1' },
  { id: 'folder2', name: 'Folder 2' },
  { id: 'folder3', name: 'Folder 3' },
  { id: 'folder4', name: 'Folder 4' },
  { id: 'folder5', name: 'Folder 5' },
  { id: 'folder6', name: 'Folder 6' },
  { id: 'folder7', name: 'Folder 7' },
  { id: 'folder8', name: 'Folder 8' },
  { id: 'folder9', name: 'Folder 9' },
  { id: 'folder10', name: 'Folder 10' },
  { id: 'folder11', name: 'Folder 11' },
  { id: 'folder12', name: 'Folder 12' },
  { id: 'folder13', name: 'Folder 13' },
  { id: 'folder14', name: 'Folder 14' },
  { id: 'folder15', name: 'Folder 15' },
  { id: 'folder16', name: 'Folder 16' },
  { id: 'folder17', name: 'Folder 17' },
  { id: 'folder18', name: 'Folder 18' },
  { id: 'folder19', name: 'Folder 19' },
  { id: 'folder20', name: 'Folder 20' },
];
export const setMarkItemEvents = ($root, args) => {
  const $list = $root.querySelector('div');
  markItemOptions.forEach(option => {
    $list.innerHTML += `
            <alk-mark-item
                key="${option.id}"
                label="${option.name}"
                mark-tag="${args.tag}"
                is-case-sensitive="${args.caseSensitive}"
                ></alk-mark-item>
        `;
  });
  const items = $root.querySelectorAll('alk-mark-item');
  items.forEach(($item) => {
    $item.ignoreChars = args.ignoreChars;
  });
  const $autocompleteEl = $root.querySelector('alk-autocomplete');
  $autocompleteEl.addEventListener('alk-autocomplete_like', ({ detail: { value } }) => {
    const items = $root.ownerDocument.documentElement.querySelectorAll('alk-mark-item');
    items.forEach(($item) => {
      $item.pattern = value;
    });
  });
};
export const setTypeaheadSelectEvents = ($el, args, hasPinnedOptions) => {
  let selectedValue;
  $el.options = hasPinnedOptions ? optionsWithPinned : globalOptions;
  $el.isDisabled = args.isDisabled;
  $el.isReadOnly = args.isReadonly;
  $el.hasTooltip = args.hasTooltip;
  $el.isRestoreValueOnBlurEnable = args.restoreValueOnBlur;
  $el.tooltipCustomClass = 'custom-class';
  if (selectedValue) {
    $el.value = selectedValue;
  }
  prepareListeners($el, args);
  $el.addEventListener('alkValueChange', (event) => {
    args.alkValueChange(`[selection changed]`, event.detail.value);
    $el.value = event.detail.value;
    selectedValue = event.detail.value;
  });
};
export const setAsyncTypeaheadSelectEvents = ($el, args, hasMoreOptions, hasViewMore) => {
  let selectedValue;
  let options = hasMoreOptions ? asyncOptionsMore : asyncOptions;
  $el.fetchOptions = (term) => {
    return of(options.filter((option) => {
      return option.name.toLowerCase().includes(term.toLowerCase());
    })).pipe(delay(1000));
  };
  $el.isDisabled = args.isDisabled;
  $el.isReadOnly = args.isReadonly;
  $el.hasTooltip = args.hasTooltip;
  $el.restoreValueOnBlur = args.restoreValueOnBlur;
  if (selectedValue) {
    $el.value = selectedValue;
  }
  if (hasViewMore) {
    $el.hasMoreItems = true;
    $el.addEventListener('alkViewMore', () => {
      console.log('[view more items]');
      options = asyncOptionsMore;
      $el.hasMoreItems = false;
    });
  }
  prepareListeners($el, args);
  $el.addEventListener('alkValueChange', (event) => {
    args.alkValueChange(`[selection changed]`, event.detail.value);
    $el.value = event.detail.value;
    selectedValue = event.detail.value;
  });
};
export const setTypeaheadSelectControls = ($root, $el) => {
  $root.querySelector('#openfin').addEventListener('click', () => {
    alert(`openfin --launch --URL ${location.href}`);
  });
  $root.querySelector('#apply-focus').addEventListener('click', () => {
    $el.applyFocus();
  });
};
export function prepareForList(container, args) {
  setList(container);
  addLikeListener(container, args);
  addSelectionListener(container, args);
}
export function prepareForKeyboard(container) {
  addKeyboardListener(container);
  addEscListener(container);
}
const ignores = ['/', ' ', '-'];
const fetchOptions = (apps) => (term) => {
  const reg = new RegExp(encodeURI(term.replace(/[* ]/g, '')), 'gi');
  return apps.filter((it) => it.name.replace(RegExp(addIgnores(ignores), 'gi'), '').search(reg) > -1);
};
const term$ = new BehaviorSubject('');
const results$ = term$.pipe(filterWithDebounce(150)(fetchOptions(globalOptions)));
const goDown = (options) => ($list) => {
  if (options.length > 0) {
    $list.selectDown();
  }
};
const goUp = (options) => ($list) => {
  if (options.length > 1) {
    $list.selectUp();
  }
};
const onEnter = (options) => ($list, $autocompleteEl) => {
  const selectedItem = options[$list.hoveredIndex];
  $autocompleteEl.value = selectedItem.name;
  term$.next('');
  $list.selectedIndex = globalOptions.findIndex(opt => opt.id === selectedItem.id);
};
const keyActions = (options) => ({
  [KEY_KEYS_CONSTANTS.DOWN_KEY]: goDown(options),
  [KEY_KEYS_CONSTANTS.RIGHT_KEY]: goDown(options),
  [KEY_KEYS_CONSTANTS.UP_KEY]: goUp(options),
  [KEY_KEYS_CONSTANTS.LEFT_KEY]: goUp(options),
  [KEY_KEYS_CONSTANTS.ENTER_KEY]: onEnter(options),
});
const handleSearchKey = ($list, $autocompleteEl) => async ({ detail: { key } }) => {
  const options = $list.options;
  (keyActions(options)[key] || noop)($list, $autocompleteEl);
};
const setList = (container) => {
  const $el = document.createElement('alk-autocomplete-list');
  results$.subscribe(async (results) => {
    $el.options = results;
    const term = term$.getValue();
    await new Promise((resolve => setTimeout(resolve, 0)));
    const items = $el.querySelectorAll('alk-mark-item');
    items.forEach(($item) => {
      $item.ignoreChars = ignores;
      $item.pattern = term;
    });
  });
  container.querySelector('main').appendChild($el);
};
const addLikeListener = (container, args) => {
  const $autocompleteEl = container.querySelector('alk-autocomplete');
  $autocompleteEl.addEventListener('alk-autocomplete_like', ({ detail: { value } }) => {
    args.alkValueChange(`[input changed]`, value);
    term$.next(value);
  });
};
const addSelectionListener = (container, args) => {
  const $autocompleteEl = container.querySelector('alk-autocomplete');
  const $list = container.querySelector('alk-autocomplete-list');
  $list.addEventListener('alk-autocomplete-list_item-selected', (event) => {
    args.alkAutocompleteListItemSelected(`[selection changed]`, event.detail);
    $list.selectedIndex = $list.options.indexOf(event.detail);
    $autocompleteEl.value = event.detail.name;
    term$.next('');
  });
};
const addKeyboardListener = (container) => {
  const $autocompleteEl = container.querySelector('alk-autocomplete');
  const $list = container.querySelector('alk-autocomplete-list');
  $autocompleteEl.addEventListener('alk-autocomplete_keydown', handleSearchKey($list, $autocompleteEl));
};
const addEscListener = (container) => {
  const $autocompleteEl = container.querySelector('alk-autocomplete');
  $autocompleteEl.addEventListener('keydown', (event) => {
    if (event.code === KEY_KEYS_CONSTANTS.ESC_KEY) {
      $autocompleteEl.restoreValue();
    }
  });
};
function prepareListeners($el, args) {
  $el.addEventListener('alkElementClear', () => {
    args.alkValueChange(`[selection cleared]`);
    $el.value = undefined;
  });
  $el.addEventListener('alkElementBlur', (event) => {
    args.alkElementBlur(`[Blured]`, event.detail);
  });
  $el.addEventListener('alkElementFocus', (event) => {
    args.alkElementBlur(`[Focused]`, event.detail);
  });
  $el.addEventListener('keydown', (event) => {
    if (event.code === KEY_KEYS_CONSTANTS.ESC_KEY) {
      $el.restoreValue();
    }
  });
}
//# sourceMappingURL=alk-autocomplete.utils.stories.js.map
